module.exports = {"659006001":"迎宾街道","659006100":"博古其镇","659006101":"双丰镇","659006102":"河畔镇","659006103":"高桥镇","659006104":"天湖镇","659006105":"开泽镇","659006106":"米兰镇","659006107":"金山镇","659006108":"南屯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659006.json
// module id = 3298
// module chunks = 0